import WifiIcon from '@mui/icons-material/Wifi';

import { colors } from 'theme/colors';

import { OfflineReadyContainer, OfflineReadyInternalContainer, OfflineReadyText, OfflineReadyTitle } from './styles';

const OfflineReady = (): React.ReactElement => (
  <OfflineReadyContainer>
    <OfflineReadyInternalContainer>
      <WifiIcon sx={{ color: colors.primary.main }} />

      <div>
        <OfflineReadyTitle>This form is ready for offline</OfflineReadyTitle>
        <OfflineReadyText>You can fill and submit this form even when you lose internet connection.</OfflineReadyText>
      </div>
    </OfflineReadyInternalContainer>
  </OfflineReadyContainer>
);

export default OfflineReady;
